import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/authContext";
import LoaderScreen  from "../others/LoaderScreen";

const PublicRoute = ({ children }) => {
  const { authChecked, isAuthenticated } = useAuth();

  if (!authChecked) {
    return <LoaderScreen />;
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default PublicRoute;